import { GaugeModel } from '../models/gauge/gauge.model';

export const /** @type {?} */ GaugeTemplates = {
  defaultTemplate: {
    property: new GaugeModel({
      display: true,
      disable: false,
      max: 100,
      type: 'full',
      size: 150,
      value: 0,
      label: '',
      prefix: '',
      suffix: '',
      inputValue: true,
      animationDuration: 1
    })
  }
}
